<template>
  <div
    ref="blockWrapper"
    :class="['buttons-bottom-header__item _with-popup', {'_with-popup--active': isShowPopup}]"
    data-list-type="jsCart"
  >
    <a href="/personal/cart/" class="buttons-bottom-header__link">
      <div class="buttons-bottom-header__icon">
        <svg
          width="19" height="20"
          viewBox="0 0 19 20" fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd" clip-rule="evenodd"
            d="M6.90117 4.5C7.31301 3.33481 8.42425 2.5 9.73047 2.5C11.0367 2.5 12.1479 3.33481 12.5598 4.5H6.90117ZM4.83049 4.5C5.29376 2.21776 7.31151 0.5 9.73047 0.5C12.1494 0.5 14.1672 2.21776 14.6305 4.5H15.8594C16.9123 4.5 17.7849 5.31637 17.8549 6.36696L18.7305 19.5H0.730469L1.606 6.36696C1.67604 5.31637 2.54865 4.5 3.60157 4.5H4.83049ZM2.86824 17.5L3.60157 6.5H15.8594L16.5927 17.5H2.86824Z" fill="#474747"
          />
        </svg>
        <div class="items-count" style="display: none">1</div>
        <div v-if="countItems > 0" class="buttons-bottom-header__icon-count items-count__show">
          {{ countItems }}
        </div>
      </div>
      <span>Корзина</span>
    </a>
    <div class="buttons-bottom-header__item-popup">
      <div class="buttons-bottom-header__added-products jsCart">
        <template v-for="(item, key) in items">
          <header-product
            :key="`header-basket-product-${key}`"
            :item="item"
            @deleteItem="deleteItem"
          />
        </template>
      </div>
      <div class="buttons-bottom-header__btn-wrapper">
        <a class="buttons-bottom-header__btn _btn" href="/personal/cart/">
          <p>Перейти в корзину</p>
          <span />
        </a>
      </div>
    </div>
  </div>
</template>
<script>

import HeaderProduct from '@/components/header-product.vue';
import initHeaderButtonsEffect from '../../../assets/js/modules/function-header-buttons-effect';
import { storageGet, storageSet } from '../../../assets/js/modules/libs/localStorage';

export default {
  name: 'app',
  components: {
    HeaderProduct,
  },
  data() {
    return {
      items: {},
      isShowPopup: false,
      isFirstLoad: true,
    };
  },
  computed: {
    countItems() {
      if (this.items) return Object.keys(this.items).length;
      return 0;
    },
    isSessionIdUpdate() {
      return window.isSessionIdUpdate;
    },
  },
  watch: {
    countItems(newValue, oldValue) {
      if (newValue > oldValue && !this.isFirstLoad && !this.isSessionIdUpdate) {
        this.isShowPopup = true;
        setTimeout(() => {
          this.isShowPopup = false;
        }, 2000);
      }
      if (this.isFirstLoad) this.isFirstLoad = false;
    },
  },
  mounted() {
    this.items = storageGet('basketItems');
    if (!this.items?.length) {
      queueMicrotask(() => {
        this.isFirstLoad = false;
      });
    }

    initHeaderButtonsEffect(document.querySelector('[data-list-type="jsCart"]'));
    this.handlerChanges();
  },
  methods: {
    handlerChanges() {
      window.addEventListener('basketUpdate', () => {
        this.items = storageGet('basketItems');
      });
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          this.items = storageGet('basketItems');
          window.basketUpdate();
        }
      });
    },
    async deleteItem(id) {
      const queryString = new URLSearchParams({
        id,
      });
      const response = await fetch(`/local/ajax/basket/deleteItem.php?${queryString}`, {
        method: 'DELETE',
      });
      if (response.ok) {
        const items = await response.json();

        if (Array.isArray(items) && !items.length) {
          this.isPopupShow = false;
          this.$refs.blockWrapper.classList.remove('_with-popup--active');
          setTimeout(() => {
            this.updateItems(items);
          }, 500);
        } else {
          this.updateItems(items);
        }
      }
    },
    updateItems(items) {
      this.items = items;
      storageSet({ key: 'basketItems', value: items });
      storageSet({ key: 'lastTimeBasketUpdate', value: Date.now() });
      window.basketUpdate();
    },
  },
};
</script>
